(function() {
  'use strict';

  // ---------------------------------------------------------------------------
  // 1. STATE
  // ---------------------------------------------------------------------------

  var advisorState = {
    q1_starting_point: null,
    q2_holdings_value: null,
    q3_tx_frequency: null,
    q4_tech_level: null,
    q5_secure_locations: null,
    q6_multiple_signers: null,
    q7_travel: null,
    q8_jurisdiction: null,
    q9_inheritance: null,
    q10_incapacitation: null,
    q11_coercion: null,
    q12_fee_tolerance: null,
    q13_disaster_test: null,
    q14_beneficiary_literacy: null
  };

  var currentQuestionIndex = 0;
  var questionHistory = [];
  var quizStarted = false;
  var quizFinished = false;
  var advancePending = false;

  // ---------------------------------------------------------------------------
  // 2. QUESTION DEFINITIONS
  // ---------------------------------------------------------------------------

  var questions = [
    {
      id: 'q1_starting_point',
      text: 'Are you already holding bitcoin, or are you researching before your first purchase?',
      options: [
        { value: 'holding', label: 'I am already holding bitcoin' },
        { value: 'about_to_buy', label: 'I am about to buy for the first time' },
        { value: 'advisor', label: 'I am researching on behalf of someone else (advisor, business)' }
      ],
      showIf: function() { return true; },
      tip: null
    },
    {
      id: 'q2_holdings_value',
      text: 'Approximately how much bitcoin are you securing or planning to secure?',
      options: [
        { value: 'under_1k', label: 'Under $1,000' },
        { value: '1k_10k', label: '$1,000 \u2013 $10,000' },
        { value: '10k_50k', label: '$10,000 \u2013 $50,000' },
        { value: '50k_100k', label: '$50,000 \u2013 $100,000' },
        { value: '100k_500k', label: '$100,000 \u2013 $500,000' },
        { value: '500k_1m', label: '$500,000 \u2013 $1,000,000' },
        { value: 'over_1m', label: 'Over $1,000,000' }
      ],
      showIf: function() { return true; },
      tip: function(val) {
        var highValues = ['10k_50k', '50k_100k', '100k_500k', '500k_1m', 'over_1m'];
        if (val && highValues.indexOf(val) !== -1) {
          return 'At this level, your seed phrase is the most valuable piece of paper you own. VaultKi X2 ensures it survives what paper cannot.';
        }
        return null;
      }
    },
    {
      id: 'q3_tx_frequency',
      text: 'How often do you expect to spend or move your bitcoin?',
      options: [
        { value: 'daily', label: 'Daily (payments, DCA spending)' },
        { value: 'weekly', label: 'Weekly' },
        { value: 'monthly', label: 'Monthly' },
        { value: 'few_times_year', label: 'A few times per year' },
        { value: 'rarely_never', label: 'Rarely or never \u2014 this is long-term savings' }
      ],
      showIf: function() { return true; },
      tip: function(val) {
        if (val === 'rarely_never') {
          return 'Long-term HODLers depend on their seed phrase for years or decades. VaultKi X2 is built to outlast paper, hard drives, and memory.';
        }
        return null;
      }
    },
    {
      id: 'q4_tech_level',
      text: 'How would you describe your experience with Bitcoin self-custody?',
      options: [
        { value: 'beginner_never', label: 'Complete beginner \u2014 I have never set up a self-custody wallet' },
        { value: 'beginner_software', label: 'Beginner \u2014 I understand seed phrases and have used a software wallet' },
        { value: 'intermediate', label: 'Intermediate \u2014 I have used a hardware wallet and understand cold storage' },
        { value: 'advanced', label: 'Advanced \u2014 I understand multisig, PSBTs, and can set up complex configurations' },
        { value: 'expert', label: 'Expert \u2014 I run my own node, build Bitcoin tooling, or work in the space' }
      ],
      showIf: function() { return true; },
      tip: null
    },
    {
      id: 'q5_secure_locations',
      text: 'Do you have access to more than one physically secure, independent location for storing a backup? (e.g., a second home, a trusted family member\'s home, a safe deposit box, an office safe)',
      options: [
        { value: 'one', label: 'No \u2014 I only have one secure location' },
        { value: 'two', label: 'Yes \u2014 I have two independent secure locations' },
        { value: 'three_plus', label: 'Yes \u2014 I have three or more independent secure locations' }
      ],
      showIf: function() { return true; },
      tip: function() {
        return 'Each secure location needs its own VaultKi X2. Geographic separation is only as strong as the durability at each point.';
      }
    },
    {
      id: 'q6_multiple_signers',
      text: 'Should more than one person be required to authorize a Bitcoin transaction from this wallet? (e.g., business treasury, joint savings, family fund)',
      options: [
        { value: 'no', label: 'No \u2014 I am the sole authorized signer' },
        { value: 'yes_two', label: 'Yes \u2014 two people must both sign' },
        { value: 'yes_threshold', label: 'Yes \u2014 a threshold of multiple signers from a larger group' }
      ],
      showIf: function() { return true; },
      tip: null
    },
    {
      id: 'q7_travel',
      text: 'How frequently do you travel internationally?',
      options: [
        { value: 'rarely', label: 'Rarely or never' },
        { value: 'few_times_year', label: 'A few times per year' },
        { value: 'frequent', label: 'Frequently \u2014 I travel internationally multiple times per month' },
        { value: 'mobile', label: 'I am internationally mobile \u2014 I live across multiple countries' }
      ],
      showIf: function() { return true; },
      tip: function(val) {
        if (val === 'frequent' || val === 'mobile') {
          return 'Leave VaultKi X2 units at fixed secure locations \u2014 never carry them through borders. Geographic distribution protects you even when you are away.';
        }
        return null;
      }
    },
    {
      id: 'q8_jurisdiction',
      text: 'Does your country of residence have compelled key disclosure laws, or do you operate in a jurisdiction where government seizure of bitcoin is a realistic concern?',
      options: [
        { value: 'no', label: 'No \u2014 standard jurisdiction with no specific concern' },
        { value: 'possibly', label: 'Possibly \u2014 I am uncertain about my jurisdiction\'s laws' },
        { value: 'yes', label: 'Yes \u2014 I operate in a high-risk or restrictive jurisdiction' }
      ],
      showIf: function() { return true; },
      tip: null
    },
    {
      id: 'q9_inheritance',
      text: 'Is ensuring your bitcoin can be passed on to heirs or designated beneficiaries an important consideration for you?',
      options: [
        { value: 'not_concern', label: 'Not a concern right now' },
        { value: 'important', label: 'Important \u2014 I want a plan but haven\'t set one up' },
        { value: 'critical', label: 'Critical \u2014 I need a working inheritance setup now' }
      ],
      showIf: function() { return true; },
      tip: function(val) {
        if (val === 'important' || val === 'critical') {
          return 'Each heir or trustee location needs its own VaultKi X2. It is what makes a key accessible after decades \u2014 not paper that degrades.';
        }
        return null;
      }
    },
    {
      id: 'q10_incapacitation',
      text: 'Beyond inheritance, do you need someone to be able to access your bitcoin if you become temporarily or permanently incapacitated \u2014 unable to act on your own behalf?',
      options: [
        { value: 'no', label: 'No \u2014 I am the only person who will ever need access while I am alive' },
        { value: 'yes_family', label: 'Yes \u2014 a family member or trusted person should be able to act on my behalf' },
        { value: 'yes_professional', label: 'Yes \u2014 a professional (lawyer, executor) should have conditional access' }
      ],
      showIf: function() {
        return advisorState.q9_inheritance === 'important' || advisorState.q9_inheritance === 'critical';
      },
      tip: null
    },
    {
      id: 'q11_coercion',
      text: 'Are you concerned about the risk of physical coercion \u2014 someone forcing you to hand over your bitcoin under duress?',
      options: [
        { value: 'not_concern', label: 'Not a significant concern for my situation' },
        { value: 'somewhat', label: 'Somewhat concerned \u2014 my holdings are publicly known or visible' },
        { value: 'yes', label: 'Yes \u2014 this is a specific concern I want to design my setup around' }
      ],
      showIf: function() {
        var highVal = ['50k_100k', '100k_500k', '500k_1m', 'over_1m'];
        return highVal.indexOf(advisorState.q2_holdings_value) !== -1 ||
               advisorState.q8_jurisdiction === 'yes' ||
               advisorState.q8_jurisdiction === 'possibly';
      },
      tip: null
    },
    {
      id: 'q12_fee_tolerance',
      text: 'Are you comfortable paying an annual fee for professional custody support (approximately $120\u2013$500/year)?',
      options: [
        { value: 'yes', label: 'Yes \u2014 professional support is worth the cost for my holdings' },
        { value: 'no', label: 'No \u2014 I prefer to manage everything independently' },
        { value: 'need_info', label: 'I need to understand the trade-off before deciding' }
      ],
      showIf: function() {
        var techOk = ['intermediate', 'advanced', 'expert'].indexOf(advisorState.q4_tech_level) !== -1;
        var locOk = ['two', 'three_plus'].indexOf(advisorState.q5_secure_locations) !== -1;
        return techOk && locOk;
      },
      tip: null
    },
    {
      id: 'q13_disaster_test',
      text: 'If your home burned down tonight, would your bitcoin be recoverable?',
      options: [
        { value: 'yes_separate', label: 'Yes \u2014 I have a seed backup at a separate location' },
        { value: 'no', label: 'No \u2014 my only backup is at home' },
        { value: 'not_sure', label: 'I am not sure \u2014 I have a backup but have never tested it' }
      ],
      showIf: function() { return true; },
      tip: function(val) {
        if (val === 'no' || val === 'not_sure') {
          return 'A paper backup 10 meters from your hardware wallet is not a backup. VaultKi X2 at a second location is.';
        }
        return null;
      }
    },
    {
      id: 'q14_beneficiary_literacy',
      text: 'If someone other than you ever needed to recover access to your bitcoin, how technically capable are they?',
      options: [
        { value: 'technical', label: 'They are comfortable with technology and could follow detailed instructions' },
        { value: 'basic', label: 'They have basic technology skills but no Bitcoin-specific knowledge' },
        { value: 'not_technical', label: 'They are not technical \u2014 they would need a professional to help them' }
      ],
      showIf: function() {
        return advisorState.q9_inheritance === 'important' ||
               advisorState.q9_inheritance === 'critical' ||
               advisorState.q10_incapacitation === 'yes_family' ||
               advisorState.q10_incapacitation === 'yes_professional';
      },
      tip: null
    }
  ];

  // ---------------------------------------------------------------------------
  // 3. TIER DATA
  // ---------------------------------------------------------------------------

  var tierData = {
    'T1': {
      name: 'Hot Singlesig',
      definition: 'A free software wallet on your phone or desktop. Your private keys are on an internet-connected device. Full self-custody from day one, but permanently exposed to online threats.',
      vaultki_detail: 'Engrave your seed phrase on VaultKi X2 immediately after wallet setup. Never photograph or type your seed phrase into any device. VaultKi X2 protects your only backup from fire, water, and physical destruction.',
      setup: [
        'Download a reputable Bitcoin wallet (BlueWallet, Green Wallet, or Electrum)',
        'Write down your 12 or 24-word seed phrase on paper during setup',
        'Engrave the seed phrase on your VaultKi X2 \u2014 this is your permanent, durable backup',
        'Store VaultKi X2 in your most secure location',
        'Send a small test amount and verify the wallet works correctly',
        'Test full recovery: restore the wallet from your VaultKi X2 seed phrase on a second device to confirm the backup works'
      ],
      mistakes: [
        'Storing your seed phrase in a screenshot, note app, or cloud service \u2014 these are the first targets in any device compromise',
        'Keeping large savings in a hot wallet \u2014 move to Tier 2 (hardware wallet) when holdings exceed $1,000',
        'Skipping recovery testing \u2014 a backup you have never tested is a backup you cannot trust'
      ],
      upgrade: 'When holdings exceed $1,000, or when you think of this as savings rather than spending money, move to Tier 2 (Cold Singlesig) with a hardware wallet.'
    },
    'T2': {
      name: 'Cold Singlesig',
      definition: 'A dedicated hardware device that stores your private keys permanently offline. Remote attackers have no path to your keys. The industry-standard starting point for any serious bitcoin holder.',
      vaultki_detail: 'The hardware wallet protects your key during signing. VaultKi X2 protects your recovery. If the device is lost, stolen, or destroyed, the seed phrase on VaultKi X2 is the only way to restore your bitcoin. The device is replaceable \u2014 the seed phrase is not.',
      setup: [
        'Purchase a hardware wallet directly from the manufacturer \u2014 never from Amazon, eBay, or third-party resellers',
        'Set up the device and write down your 24-word seed phrase',
        'Engrave the seed phrase on your VaultKi X2',
        'Store VaultKi X2 in your most secure location \u2014 not next to the hardware wallet',
        'Set a strong device PIN',
        'Send a small test amount and verify the on-screen transaction display',
        'Test full recovery: restore from your VaultKi X2 seed phrase on a second hardware wallet to confirm the backup works'
      ],
      mistakes: [
        'Buying from Amazon or resellers \u2014 pre-loaded malware and pre-copied seed phrases are documented attack vectors',
        'Storing VaultKi X2 in the same location as your hardware wallet \u2014 a single disaster destroys both',
        'Relying on the hardware wallet alone without a tested seed phrase backup'
      ],
      upgrade: 'When you want a second authentication factor, face coercion risk, or holdings exceed $50,000, add a passphrase (Tier 3).'
    },
    'T3': {
      name: 'Cold Singlesig + Passphrase',
      definition: 'A BIP39 passphrase \u2014 the "25th word" \u2014 generates a hidden wallet on top of your seed. Two independent factors required: the seed phrase AND the passphrase. Plausible deniability under coercion.',
      vaultki_detail: 'VaultKi X2 secures the seed phrase at Location A. The passphrase must be at a completely separate, independent location \u2014 never stored with the seed phrase. Two VaultKi X2 units recommended: one for the seed, one for the passphrase backup.',
      setup: [
        'Set up a hardware wallet with a standard seed phrase (Tier 2 setup)',
        'Engrave the seed phrase on VaultKi X2 #1 \u2014 store at Location A',
        'Choose a strong passphrase and write it down',
        'Engrave or securely document the passphrase on VaultKi X2 #2 \u2014 store at Location B (completely separate from Location A)',
        'Enable passphrase on your hardware wallet and load a small decoy balance on the base (no-passphrase) wallet',
        'Test full recovery: restore seed + passphrase on a second device to confirm both factors work together',
        'Verify the decoy wallet shows a valid balance (convincing under coercion)'
      ],
      mistakes: [
        'Storing the passphrase with the seed phrase \u2014 this eliminates the entire purpose of two-factor protection',
        'Relying on memory alone for the passphrase \u2014 a forgotten passphrase means permanent, irrecoverable loss',
        'Forgetting to test recovery with BOTH the seed phrase and passphrase together'
      ],
      upgrade: 'When you have multiple secure locations and holdings exceed $50,000, distribute backups (Tier 4) or consider multisig (Tier 5).'
    },
    'T4': {
      name: 'Cold Singlesig + Distributed Backup',
      definition: 'Same single-key architecture, but your seed phrase backup exists at multiple geographically independent locations. No single fire, flood, or burglary can destroy your only recovery path.',
      vaultki_detail: 'One VaultKi X2 per location \u2014 fire, water, and crush-proof at each independent site. Geographic separation is your redundancy strategy. VaultKi X2 is the physical durability guarantee at each point.',
      setup: [
        'Set up a hardware wallet with seed phrase (Tier 2 setup)',
        'Engrave the seed phrase on VaultKi X2 #1 \u2014 store at Location A (primary)',
        'Engrave the seed phrase on VaultKi X2 #2 \u2014 store at Location B (geographically independent)',
        'Optionally engrave on VaultKi X2 #3 \u2014 store at Location C for maximum redundancy',
        'Verify each location is physically secure, access-controlled, and known only to trusted parties',
        'If using a passphrase (Tier 3), maintain the passphrase at an additional independent location',
        'Test full recovery from at least one non-primary location to confirm the backup works'
      ],
      mistakes: [
        'Choosing locations in the same building or same flood/fire zone \u2014 geographic independence means truly separate',
        'Telling too many people about backup locations \u2014 each person who knows is a potential compromise vector',
        'Forgetting to update all locations if you ever change your seed phrase or wallet setup'
      ],
      upgrade: 'When holdings exceed $100,000, multiple authorized signers are needed, or you require formal inheritance planning, move to multisig (Tier 5).'
    },
    'T5': {
      name: 'Multisig',
      definition: 'Multiple independent private keys required to co-sign every transaction. In a 2-of-3 setup, you need any 2 of 3 keys to move bitcoin. No single stolen device, burned location, or compromised seed can move your funds. The gold standard for holdings above $100,000.',
      vaultki_detail: 'One VaultKi X2 per key location (3 units for seed phrases) plus one additional unit for the wallet descriptor \u2014 the xpub configuration file that defines your multisig quorum. Without the descriptor, even holding all seed phrases may be insufficient to recover funds. 4 VaultKi X2 units total.',
      setup: [
        'Purchase 3 hardware wallets from different manufacturers for maximum supply chain diversity',
        'Generate a seed phrase on each device independently \u2014 never share seeds between devices',
        'Engrave each seed phrase on a separate VaultKi X2 \u2014 one per geographic location',
        'Use Sparrow Wallet to create the multisig wallet configuration (2-of-3 recommended)',
        'Export and back up the wallet descriptor file on an additional VaultKi X2 \u2014 store separately from any seed',
        'Send a small test amount to the multisig wallet',
        'Test a full spend using 2 of 3 keys to confirm signing works correctly',
        'Test full wallet recovery: import the descriptor and 2 seed phrases on fresh devices to verify recovery'
      ],
      mistakes: [
        'Forgetting to back up the wallet descriptor \u2014 without it, recovery with seed phrases alone may fail',
        'Co-locating multiple keys at the same site \u2014 each key must be at a geographically independent location',
        'Confusing Shamir Secret Sharing with multisig \u2014 SSS temporarily reassembles a single key, creating a single point of failure that multisig eliminates'
      ],
      upgrade: 'When holdings exceed $1,000,000 and you have expert-level operational competency, consider air-gapped multisig (Tier 6).'
    },
    'T5b': {
      name: 'Assisted Multisig',
      definition: 'A professionally guided 2-of-3 multisig where you hold 2 keys and a trusted service (Casa, Unchained Capital) holds 1 as a recovery fallback. You can transact at any time using only your own keys. The service cannot move your bitcoin without you. This is self-custody.',
      vaultki_detail: 'Two VaultKi X2 units \u2014 one per key location you personally hold. Your VaultKi X2 units are what make you independent of the service: even if the service closes, you hold two of three keys and can always move your funds. One additional unit for the descriptor backup. 3 VaultKi X2 units total.',
      setup: [
        'Choose a provider (Casa or Unchained Capital) and complete onboarding',
        'Set up your 2 personal keys on hardware wallets following the provider\'s guided process',
        'Engrave each of your 2 seed phrases on a separate VaultKi X2',
        'Store each VaultKi X2 at a separate, secure, geographic location',
        'Back up the wallet descriptor on a third VaultKi X2',
        'Complete a test transaction using your 2 keys to confirm you can transact without the service',
        'Test full recovery through the provider\'s process to understand the recovery path'
      ],
      mistakes: [
        'Assuming the service can unilaterally access your bitcoin \u2014 they hold 1 of 3 keys, not a majority',
        'Neglecting to keep your own key backups current \u2014 the service key is a fallback, not your primary recovery',
        'Storing both of your personal keys at the same location \u2014 geographic independence applies to your keys too'
      ],
      upgrade: 'When holdings exceed $1,000,000 and you have expert operational competency, consider independent multisig (Tier 5) or air-gapped multisig (Tier 6).'
    },
    'T6': {
      name: 'Air-Gapped Multisig',
      definition: 'The apex of self-custody. Each signing device is permanently disconnected from all networks. Transactions transfer via QR code or microSD card only. Combined with multisig, no single physical compromise can produce a valid signature. No recovery service, no safety net.',
      vaultki_detail: 'One VaultKi X2 per geographic signing location, plus one for the descriptor. At this tier there is no customer support and no recovery service. The physical durability of VaultKi X2 is the non-negotiable foundation. 4 VaultKi X2 units total.',
      setup: [
        'Purchase 3 air-gap-capable hardware wallets (Coldcard Mk4, SeedSigner, Foundation Passport)',
        'Permanently disable all connectivity on each device (WiFi, Bluetooth, USB data, NFC)',
        'Generate a seed phrase on each air-gapped device independently',
        'Engrave each seed phrase on a separate VaultKi X2 \u2014 one per geographic signing location',
        'Set up a watch-only multisig wallet in Sparrow on a networked computer',
        'Export and back up the wallet descriptor on an additional VaultKi X2',
        'Practice the full PSBT signing workflow: create transaction \u2192 export via QR/microSD \u2192 sign on each device \u2192 broadcast',
        'Test full recovery: reconstruct the wallet from descriptor + 2 seed phrases on fresh air-gapped devices'
      ],
      mistakes: [
        'Using a device that has ever been connected to a network \u2014 air-gapped means permanently and completely disconnected from day one',
        'Transferring PSBTs via USB cable instead of QR code or microSD card \u2014 USB data transfer breaks the air gap',
        'Operating without extensive documentation \u2014 at this tier, your operational procedures are as critical as your keys'
      ],
      upgrade: 'This is the highest tier. Reconsider your setup if your threat model changes, your operational discipline falters, or the number of required signers changes.'
    }
  };

  // ---------------------------------------------------------------------------
  // 4. UNIT COUNTS AND LABEL MAPS
  // ---------------------------------------------------------------------------

  var vaultKiUnitCount = {
    'T1': 1, 'LN': 1, 'T2': 1, 'T3': 2, 'T4': 3, 'T5': 4, 'T5b': 3, 'T6': 4
  };

  var holdingsLabels = {
    'under_1k': 'under $1,000',
    '1k_10k': '$1,000\u2013$10,000',
    '10k_50k': '$10,000\u2013$50,000',
    '50k_100k': '$50,000\u2013$100,000',
    '100k_500k': '$100,000\u2013$500,000',
    '500k_1m': '$500,000\u2013$1,000,000',
    'over_1m': 'over $1,000,000'
  };

  var frequencyLabels = {
    'daily': 'daily',
    'weekly': 'weekly',
    'monthly': 'monthly',
    'few_times_year': 'a few times per year',
    'rarely_never': 'rarely or never'
  };

  var techLabels = {
    'beginner_never': 'complete beginner',
    'beginner_software': 'beginner',
    'intermediate': 'intermediate',
    'advanced': 'advanced',
    'expert': 'expert'
  };

  var locationLabels = {
    'one': 'one secure location',
    'two': 'two secure locations',
    'three_plus': 'three or more secure locations'
  };

  // ---------------------------------------------------------------------------
  // 5. ANALYTICS
  // ---------------------------------------------------------------------------

  function trackEvent(eventName, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: eventName };
    if (data) {
      var keys = Object.keys(data);
      for (var i = 0; i < keys.length; i++) {
        payload[keys[i]] = data[keys[i]];
      }
    }
    window.dataLayer.push(payload);
  }

  // ---------------------------------------------------------------------------
  // 6. ELIMINATION ENGINE
  // ---------------------------------------------------------------------------

  function getEliminatedTiers(state) {
    var eliminated = {};

    // Q2 -- Holdings value
    if (state.q2_holdings_value === 'under_1k') {
      eliminated['T5'] = true;
      eliminated['T5b'] = true;
      eliminated['T6'] = true;
    } else if (state.q2_holdings_value === '1k_10k') {
      eliminated['T6'] = true;
    } else if (state.q2_holdings_value === '10k_50k') {
      eliminated['T1'] = true;
      eliminated['T6'] = true;
    } else if (state.q2_holdings_value === '50k_100k') {
      eliminated['T1'] = true;
    } else if (state.q2_holdings_value === '100k_500k') {
      eliminated['T1'] = true;
    } else if (state.q2_holdings_value === '500k_1m') {
      eliminated['T1'] = true;
      eliminated['T2'] = true;
      eliminated['T3'] = true;
    } else if (state.q2_holdings_value === 'over_1m') {
      eliminated['T1'] = true;
      eliminated['T2'] = true;
      eliminated['T3'] = true;
      eliminated['T4'] = true;
    }

    // Q3 -- Transaction frequency
    if (state.q3_tx_frequency === 'daily') {
      eliminated['T6'] = true;
    }
    if (state.q3_tx_frequency === 'rarely_never' && state.q2_holdings_value !== 'under_1k') {
      eliminated['T1'] = true;
    }

    // Q4 -- Technical level
    if (state.q4_tech_level === 'beginner_never') {
      eliminated['T5'] = true;
      eliminated['T6'] = true;
    } else if (state.q4_tech_level === 'beginner_software') {
      eliminated['T6'] = true;
    } else if (state.q4_tech_level === 'intermediate') {
      if (state.q2_holdings_value !== 'over_1m') {
        eliminated['T6'] = true;
      }
    }

    // Q5 -- Secure locations
    if (state.q5_secure_locations === 'one') {
      eliminated['T4'] = true;
      eliminated['T5'] = true;
    }

    // Q6 -- Multiple signers
    if (state.q6_multiple_signers === 'yes_two' || state.q6_multiple_signers === 'yes_threshold') {
      eliminated['T1'] = true;
      eliminated['T2'] = true;
      eliminated['T3'] = true;
      eliminated['T4'] = true;
    }

    // Q12 -- Fee tolerance
    if (state.q12_fee_tolerance === 'no') {
      eliminated['T5b'] = true;
    }

    return eliminated;
  }

  // ---------------------------------------------------------------------------
  // 7. RECOMMENDATION ENGINE
  // ---------------------------------------------------------------------------

  function getPrimaryTier(state) {
    // HARD OVERRIDES -- multiple signers required
    if (state.q6_multiple_signers === 'yes_two' || state.q6_multiple_signers === 'yes_threshold') {
      if (state.q12_fee_tolerance === 'yes') return 'T5b';
      if (state.q4_tech_level === 'advanced' || state.q4_tech_level === 'expert') return 'T5';
      return 'T5b';
    }

    // OVER $1M
    if (state.q2_holdings_value === 'over_1m') {
      if (state.q4_tech_level === 'expert') return 'T6';
      return 'T5';
    }

    // $500K--$1M
    if (state.q2_holdings_value === '500k_1m') {
      if (state.q12_fee_tolerance === 'yes') return 'T5b';
      return 'T5';
    }

    // $100K--$500K
    if (state.q2_holdings_value === '100k_500k') {
      if (state.q5_secure_locations === 'one') return 'T3';
      if (state.q12_fee_tolerance === 'yes' &&
          (state.q4_tech_level === 'beginner_software' || state.q4_tech_level === 'intermediate')) {
        return 'T5b';
      }
      return 'T5';
    }

    // $50K--$100K
    if (state.q2_holdings_value === '50k_100k') {
      if ((state.q9_inheritance === 'important' || state.q9_inheritance === 'critical') &&
          state.q5_secure_locations !== 'one') {
        return 'T5';
      }
      if (state.q5_secure_locations !== 'one') return 'T4';
      return 'T3';
    }

    // $10K--$50K
    if (state.q2_holdings_value === '10k_50k') {
      if (state.q5_secure_locations !== 'one' &&
          (state.q4_tech_level === 'intermediate' || state.q4_tech_level === 'advanced' || state.q4_tech_level === 'expert')) {
        return 'T4';
      }
      return 'T2';
    }

    // $1K--$10K
    if (state.q2_holdings_value === '1k_10k') {
      return 'T2';
    }

    // Under $1K
    return 'T1';
  }

  function getSecondaryRecommendations(state, primaryTier) {
    var secondary = [];

    // Passphrase upgrade
    if (['T3', 'T4', 'T5', 'T5b', 'T6'].indexOf(primaryTier) === -1) {
      if (state.q8_jurisdiction === 'yes' || state.q8_jurisdiction === 'possibly' ||
          state.q11_coercion === 'somewhat' || state.q11_coercion === 'yes') {
        secondary.push({
          tier: 'T3',
          reason: 'Passphrase recommended for plausible deniability and coercion protection'
        });
      }
    }

    // Distributed backup
    if ((primaryTier === 'T2' || primaryTier === 'T3') && state.q5_secure_locations !== 'one') {
      secondary.push({
        tier: 'T4',
        reason: 'Distributed backup for disaster resilience across multiple locations'
      });
    }

    // Inheritance upgrade -- Shamir note
    if ((primaryTier === 'T1' || primaryTier === 'T2' || primaryTier === 'T3') &&
        (state.q9_inheritance === 'important' || state.q9_inheritance === 'critical')) {
      secondary.push({
        tier: 'SHAMIR_NOTE',
        reason: 'Consider Shamir Secret Sharing for inheritance \u2014 with the caveat that it is a singlesig modification, not multisig. SSS temporarily reassembles a single key during reconstruction, creating a single point of failure that multisig eliminates.'
      });
    }

    // Lightning track
    if (state.q3_tx_frequency === 'daily') {
      secondary.push({
        tier: 'LN',
        reason: 'Lightning Network for daily payments \u2014 keep savings in your primary tier'
      });
    }

    // T5b option
    if (primaryTier === 'T5' && state.q12_fee_tolerance === 'yes' &&
        state.q4_tech_level !== 'advanced' && state.q4_tech_level !== 'expert') {
      secondary.push({
        tier: 'T5b',
        reason: 'Assisted multisig as an alternative \u2014 professional guidance with the same security model'
      });
    }

    return secondary;
  }

  // ---------------------------------------------------------------------------
  // 8. QUIZ HELPERS
  // ---------------------------------------------------------------------------

  function getVisibleQuestions() {
    var visible = [];
    for (var i = 0; i < questions.length; i++) {
      if (questions[i].showIf()) {
        visible.push(i);
      }
    }
    return visible;
  }

  function getNextVisibleIndex(fromGlobalIndex) {
    for (var i = fromGlobalIndex + 1; i < questions.length; i++) {
      if (questions[i].showIf()) {
        return i;
      }
    }
    return -1; // no more questions
  }

  function getQuestionNumber(globalIndex) {
    var count = 0;
    for (var i = 0; i <= globalIndex; i++) {
      if (questions[i].showIf()) {
        count++;
      }
    }
    return count;
  }

  function getTotalVisibleQuestions() {
    var count = 0;
    for (var i = 0; i < questions.length; i++) {
      if (questions[i].showIf()) {
        count++;
      }
    }
    return count;
  }

  function resetState() {
    var keys = Object.keys(advisorState);
    for (var i = 0; i < keys.length; i++) {
      advisorState[keys[i]] = null;
    }
    currentQuestionIndex = 0;
    questionHistory = [];
    quizStarted = false;
    quizFinished = false;
    advancePending = false;
  }

  function buildConcernList(state) {
    var concerns = [];
    if (state.q7_travel === 'frequent' || state.q7_travel === 'mobile') {
      concerns.push('frequent international travel');
    }
    if (state.q8_jurisdiction === 'yes') {
      concerns.push('high-risk jurisdiction');
    } else if (state.q8_jurisdiction === 'possibly') {
      concerns.push('uncertain jurisdiction');
    }
    if (state.q9_inheritance === 'important') {
      concerns.push('inheritance planning');
    } else if (state.q9_inheritance === 'critical') {
      concerns.push('critical inheritance requirement');
    }
    if (state.q10_incapacitation === 'yes_family' || state.q10_incapacitation === 'yes_professional') {
      concerns.push('incapacitation access');
    }
    if (state.q11_coercion === 'somewhat' || state.q11_coercion === 'yes') {
      concerns.push('coercion risk');
    }
    return concerns;
  }

  // ---------------------------------------------------------------------------
  // 9. DOM CREATION HELPERS
  // ---------------------------------------------------------------------------

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      var keys = Object.keys(attrs);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (key === 'className') {
          node.className = attrs[key];
        } else if (key === 'textContent') {
          node.textContent = attrs[key];
        } else if (key.indexOf('on') === 0) {
          node.addEventListener(key.substring(2).toLowerCase(), attrs[key]);
        } else {
          node.setAttribute(key, attrs[key]);
        }
      }
    }
    if (children) {
      if (typeof children === 'string') {
        node.textContent = children;
      } else if (Array.isArray(children)) {
        for (var j = 0; j < children.length; j++) {
          if (children[j]) {
            if (typeof children[j] === 'string') {
              node.appendChild(document.createTextNode(children[j]));
            } else {
              node.appendChild(children[j]);
            }
          }
        }
      } else if (children.nodeType) {
        node.appendChild(children);
      }
    }
    return node;
  }

  // ---------------------------------------------------------------------------
  // 10. KNOWLEDGE BASE -- TAB SWITCHING
  // ---------------------------------------------------------------------------

  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[id^="panel-"]');

    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function(e) {
        var targetTab = this.getAttribute('data-tab');

        // Remove active from all tabs
        for (var t = 0; t < tabs.length; t++) {
          tabs[t].classList.remove('vk-advisor__tab--active');
          tabs[t].setAttribute('aria-selected', 'false');
        }

        // Add active to clicked
        this.classList.add('vk-advisor__tab--active');
        this.setAttribute('aria-selected', 'true');

        // Hide all panels, show target
        for (var p = 0; p < panels.length; p++) {
          var panelId = panels[p].id;
          if (panelId === 'panel-' + targetTab) {
            panels[p].removeAttribute('hidden');
            panels[p].classList.add('vk-advisor__panel--active');
          } else {
            panels[p].setAttribute('hidden', '');
            panels[p].classList.remove('vk-advisor__panel--active');
          }
        }

        // Analytics
        var tabMap = {
          'self-custody': 'self_custody',
          'third-party': 'third_party',
          'indirect': 'indirect_exposure'
        };
        trackEvent('vk_advisor_tab_switch', {
          tab: tabMap[targetTab] || targetTab
        });
      });
    }
  }

  // ---------------------------------------------------------------------------
  // 11. KNOWLEDGE BASE -- ACCORDIONS
  // ---------------------------------------------------------------------------

  function initAccordions(root) {
    var tiers = root.querySelectorAll('.vk-tier');

    for (var i = 0; i < tiers.length; i++) {
      var header = tiers[i].querySelector('.vk-tier__header');
      if (header) {
        header.addEventListener('click', function() {
          var button = this;
          var article = this.closest('.vk-tier');
          var body = article.querySelector('.vk-tier__body');
          var isExpanded = button.getAttribute('aria-expanded') === 'true';

          if (isExpanded) {
            // Closing
            button.setAttribute('aria-expanded', 'false');
            body.style.maxHeight = '0';
            setTimeout(function() {
              body.hidden = true;
            }, 350);
          } else {
            // Opening — remove hidden first so we can measure scrollHeight
            body.hidden = false;
            button.setAttribute('aria-expanded', 'true');
            body.style.maxHeight = body.scrollHeight + 'px';

            // Analytics
            var tierId = article.getAttribute('data-tier');
            if (tierId) {
              trackEvent('vk_advisor_tier_expanded', { tier_id: tierId });
            }
          }
        });
      }
    }
  }

  // ---------------------------------------------------------------------------
  // 12. MODE TOGGLE (KB <-> Quiz)
  // ---------------------------------------------------------------------------

  function initModeToggle(root) {
    var modeButtons = root.querySelectorAll('[data-mode]');
    var kbPanel = root.querySelector('[data-mode-panel="kb"]');
    var quizPanel = root.querySelector('[data-mode-panel="quiz"]');

    if (!kbPanel || !quizPanel) return;

    for (var i = 0; i < modeButtons.length; i++) {
      modeButtons[i].addEventListener('click', function() {
        var mode = this.getAttribute('data-mode');

        // Update button states
        for (var b = 0; b < modeButtons.length; b++) {
          modeButtons[b].classList.remove('vk-advisor__mode-btn--active');
        }
        this.classList.add('vk-advisor__mode-btn--active');

        if (mode === 'kb') {
          kbPanel.classList.remove('vk-kb--hidden');
          quizPanel.classList.remove('vk-quiz--active');
          quizPanel.style.display = 'none';
          kbPanel.style.display = '';
        } else if (mode === 'quiz') {
          kbPanel.classList.add('vk-kb--hidden');
          kbPanel.style.display = 'none';
          quizPanel.classList.add('vk-quiz--active');
          quizPanel.style.display = '';

          if (!quizStarted) {
            quizStarted = true;
            currentQuestionIndex = 0;
            questionHistory = [];
            trackEvent('vk_advisor_started');
            renderQuestion(root);
          } else if (quizFinished) {
            // Re-show the recommendation card (already rendered)
          } else {
            // Resume quiz at current question
            renderQuestion(root);
          }
        }
      });
    }
  }

  // ---------------------------------------------------------------------------
  // 13. REDIRECT BUTTONS
  // ---------------------------------------------------------------------------

  function initRedirects(root) {
    var redirectBtns = root.querySelectorAll('[data-redirect="self-custody"]');

    for (var i = 0; i < redirectBtns.length; i++) {
      redirectBtns[i].addEventListener('click', function() {
        var fromBranch = this.getAttribute('data-from-branch') || '';
        var fromCard = this.getAttribute('data-from-card') || '';

        // Switch to self-custody tab
        var selfTab = root.querySelector('[data-tab="self-custody"]');
        if (selfTab) {
          selfTab.click();
        }

        // Switch to KB mode if in quiz mode
        var kbBtn = root.querySelector('[data-mode="kb"]');
        if (kbBtn) {
          kbBtn.click();
        }

        // Analytics
        trackEvent('vk_advisor_redirect_to_self_custody', {
          from_branch: fromBranch,
          from_card: fromCard
        });
      });
    }
  }

  // ---------------------------------------------------------------------------
  // 14. QUIZ RENDERING
  // ---------------------------------------------------------------------------

  function renderQuestion(root) {
    var quizRoot = root.querySelector('#vk-quiz-root');
    if (!quizRoot) return;

    var question = questions[currentQuestionIndex];
    if (!question) return;

    var qNum = getQuestionNumber(currentQuestionIndex);
    var totalQ = getTotalVisibleQuestions();

    // Clear quiz root
    while (quizRoot.firstChild) {
      quizRoot.removeChild(quizRoot.firstChild);
    }

    // Progress bar
    var progressPercent = ((qNum - 1) / totalQ) * 100;
    var progressContainer = el('div', { className: 'vk-quiz__progress' }, [
      el('div', { className: 'vk-quiz__progress-bar' }, [
        el('div', {
          className: 'vk-quiz__progress-fill',
          style: 'width: ' + progressPercent + '%'
        })
      ]),
      el('span', { className: 'vk-quiz__progress-text' }, 'Question ' + qNum + ' of ' + totalQ)
    ]);
    quizRoot.appendChild(progressContainer);

    // Question card
    var questionCard = el('div', { className: 'vk-quiz__question-card' });
    var questionText = el('h3', { className: 'vk-quiz__question-text' }, question.text);
    questionCard.appendChild(questionText);

    // Options
    var optionsContainer = el('div', { className: 'vk-quiz__options' });
    var currentAnswer = advisorState[question.id];

    for (var i = 0; i < question.options.length; i++) {
      (function(option) {
        var optionClasses = 'vk-quiz__option';
        if (currentAnswer === option.value) {
          optionClasses += ' vk-quiz__option--selected';
        }
        var optionBtn = el('button', {
          className: optionClasses,
          'data-value': option.value,
          type: 'button'
        }, option.label);

        optionBtn.addEventListener('click', function() {
          if (advancePending) return;

          // Set state
          advisorState[question.id] = option.value;

          // Update visual selection
          var allOpts = optionsContainer.querySelectorAll('.vk-quiz__option');
          for (var o = 0; o < allOpts.length; o++) {
            allOpts[o].classList.remove('vk-quiz__option--selected');
          }
          this.classList.add('vk-quiz__option--selected');

          // Analytics
          var qIdShort = question.id.split('_')[0];
          trackEvent('vk_advisor_question_answered', {
            question_id: qIdShort,
            answer_value: option.value
          });

          // Show tip if applicable
          showTipIfApplicable(quizRoot, question, option.value);

          // Update live shortlist
          renderShortlist(root, quizRoot);

          // Auto-advance after delay
          advancePending = true;
          setTimeout(function() {
            advancePending = false;
            advanceQuiz(root);
          }, 600);
        });

        optionsContainer.appendChild(optionBtn);
      })(question.options[i]);
    }

    questionCard.appendChild(optionsContainer);

    // Tip area (initially empty, filled after answer)
    var tipArea = el('div', { className: 'vk-quiz__tip-area', id: 'vk-quiz-tip' });
    questionCard.appendChild(tipArea);

    quizRoot.appendChild(questionCard);

    // Back button
    if (questionHistory.length > 0) {
      var backBtn = el('button', {
        className: 'vk-quiz__back-btn',
        type: 'button'
      }, [
        el('span', null, '\u2190'),
        el('span', null, ' Back to previous question')
      ]);

      backBtn.addEventListener('click', function() {
        if (advancePending) return;
        goBack(root);
      });

      quizRoot.appendChild(backBtn);
    }

    // Live shortlist panel
    var shortlistContainer = el('div', { className: 'vk-quiz__shortlist', id: 'vk-quiz-shortlist' });
    quizRoot.appendChild(shortlistContainer);
    renderShortlist(root, quizRoot);

    // If there is a saved answer, show the tip
    if (currentAnswer) {
      showTipIfApplicable(quizRoot, question, currentAnswer);
    }
  }

  function showTipIfApplicable(quizRoot, question, value) {
    var tipArea = quizRoot.querySelector('#vk-quiz-tip');
    if (!tipArea) return;

    // Clear existing tip
    while (tipArea.firstChild) {
      tipArea.removeChild(tipArea.firstChild);
    }

    var tipText = null;
    if (typeof question.tip === 'function') {
      tipText = question.tip(value);
    }

    if (tipText) {
      var tipEl = el('div', { className: 'vk-quiz__tip' }, [
        el('span', { className: 'vk-quiz__tip-icon' }, '\u26a0'),
        el('span', { className: 'vk-quiz__tip-text' }, tipText)
      ]);
      tipArea.appendChild(tipEl);
    }
  }

  function advanceQuiz(root) {
    // Save current index in history
    questionHistory.push(currentQuestionIndex);

    // Find next visible question
    var nextIndex = getNextVisibleIndex(currentQuestionIndex);

    if (nextIndex === -1) {
      // Quiz complete
      quizFinished = true;
      renderRecommendation(root);
    } else {
      currentQuestionIndex = nextIndex;
      renderQuestion(root);
      // Scroll quiz root into view
      var quizRoot = root.querySelector('#vk-quiz-root');
      if (quizRoot) {
        quizRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  function goBack(root) {
    if (questionHistory.length === 0) return;

    // Clear current question's answer
    var currentQuestion = questions[currentQuestionIndex];
    if (currentQuestion) {
      advisorState[currentQuestion.id] = null;
    }

    // Pop previous index
    currentQuestionIndex = questionHistory.pop();

    // Re-render
    renderQuestion(root);

    // Scroll quiz root into view
    var quizRoot = root.querySelector('#vk-quiz-root');
    if (quizRoot) {
      quizRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // ---------------------------------------------------------------------------
  // 15. LIVE SHORTLIST PANEL
  // ---------------------------------------------------------------------------

  function renderShortlist(root, quizRoot) {
    var container = quizRoot.querySelector('#vk-quiz-shortlist');
    if (!container) return;

    // Clear
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }

    // Show shortlist as soon as quiz has started (after Q1)
    if (!advisorState.q1_starting_point) return;

    var allTiers = ['T1', 'T2', 'T3', 'T4', 'T5', 'T5b', 'T6'];
    var eliminated = getEliminatedTiers(advisorState);

    var heading = el('h4', { className: 'vk-quiz__shortlist-heading' }, 'Solutions still in play');
    container.appendChild(heading);

    var tierList = el('div', { className: 'vk-quiz__shortlist-tiers' });

    for (var i = 0; i < allTiers.length; i++) {
      var tierId = allTiers[i];
      var isEliminated = eliminated[tierId] === true;
      var tierName = tierData[tierId] ? tierData[tierId].name : tierId;

      var chipClasses = 'vk-quiz__shortlist-chip';
      if (isEliminated) {
        chipClasses += ' vk-quiz__shortlist-chip--eliminated';
      }

      var chipAttrs = {
        className: chipClasses,
        href: '#tier-' + tierId,
        target: '_blank'
      };
      // Don't link eliminated tiers
      if (isEliminated) {
        chipAttrs.href = 'javascript:void(0)';
        chipAttrs.target = '';
      }
      var chipContent = el('span', null, [
        el('strong', null, tierId),
        document.createTextNode(' ' + tierName)
      ]);
      var chip = el('a', chipAttrs, [chipContent]);

      // For non-eliminated chips, add click handler to navigate to KB
      if (!isEliminated) {
        (function(tid) {
          chip.addEventListener('click', function(e) {
            e.preventDefault();
            // Switch to KB mode
            var kbBtn = root.querySelector('[data-mode="kb"]');
            if (kbBtn) kbBtn.click();
            // Switch to self-custody tab
            var selfTab = root.querySelector('[data-tab="self-custody"]');
            if (selfTab) selfTab.click();
            // Open and scroll to the tier
            var tierArticle = root.querySelector('[data-tier="' + tid + '"]');
            if (tierArticle) {
              var tierHeader = tierArticle.querySelector('.vk-tier__header');
              if (tierHeader && tierHeader.getAttribute('aria-expanded') !== 'true') {
                tierHeader.click();
              }
              setTimeout(function() {
                tierArticle.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 100);
            }
          });
        })(tierId);
      }

      tierList.appendChild(chip);
    }

    container.appendChild(tierList);

    // Lightning track note
    if (advisorState.q3_tx_frequency === 'daily') {
      var lnNote = el('div', { className: 'vk-quiz__shortlist-ln' }, 'Lightning Network added for daily payments');
      container.appendChild(lnNote);
    }
  }

  // ---------------------------------------------------------------------------
  // 16. RECOMMENDATION CARD RENDERER
  // ---------------------------------------------------------------------------

  function renderRecommendation(root) {
    var quizRoot = root.querySelector('#vk-quiz-root');
    if (!quizRoot) return;

    // Clear
    while (quizRoot.firstChild) {
      quizRoot.removeChild(quizRoot.firstChild);
    }

    var primaryTier = getPrimaryTier(advisorState);
    var secondaryRecs = getSecondaryRecommendations(advisorState, primaryTier);
    var units = vaultKiUnitCount[primaryTier] || 1;
    var data = tierData[primaryTier];

    if (!data) return;

    // Product URL
    var productUrl = root.getAttribute('data-product-url') || 'https://vaultki.com/products/vaultki-x2';

    // Track recommendation shown
    var secondaryTierIds = [];
    for (var s = 0; s < secondaryRecs.length; s++) {
      secondaryTierIds.push(secondaryRecs[s].tier);
    }
    trackEvent('vk_advisor_recommendation_shown', {
      primary_tier: primaryTier,
      secondary_tiers: secondaryTierIds,
      vaultki_units_recommended: units
    });

    // Build the card
    var card = el('div', { className: 'vk-quiz__recommendation' });

    // ---- Header ----
    var header = el('div', { className: 'vk-quiz__rec-header' });
    header.appendChild(el('h2', { className: 'vk-quiz__rec-title' }, 'Your Recommended Setup'));
    header.appendChild(el('div', { className: 'vk-quiz__rec-tier-badge' }, primaryTier + ': ' + data.name));
    card.appendChild(header);

    // ---- Profile summary ----
    var profileSection = el('div', { className: 'vk-quiz__rec-section' });
    profileSection.appendChild(el('h3', { className: 'vk-quiz__rec-section-title' }, 'Your Profile'));

    var profileList = el('ul', { className: 'vk-quiz__rec-profile' });

    if (advisorState.q2_holdings_value) {
      profileList.appendChild(el('li', null, 'Holdings: ' + (holdingsLabels[advisorState.q2_holdings_value] || advisorState.q2_holdings_value)));
    }
    if (advisorState.q3_tx_frequency) {
      profileList.appendChild(el('li', null, 'Transaction frequency: ' + (frequencyLabels[advisorState.q3_tx_frequency] || advisorState.q3_tx_frequency)));
    }
    if (advisorState.q4_tech_level) {
      profileList.appendChild(el('li', null, 'Technical level: ' + (techLabels[advisorState.q4_tech_level] || advisorState.q4_tech_level)));
    }
    if (advisorState.q5_secure_locations) {
      profileList.appendChild(el('li', null, 'Secure locations: ' + (locationLabels[advisorState.q5_secure_locations] || advisorState.q5_secure_locations)));
    }

    var concerns = buildConcernList(advisorState);
    if (concerns.length > 0) {
      profileList.appendChild(el('li', null, 'Active concerns: ' + concerns.join(', ')));
    }

    profileSection.appendChild(profileList);
    card.appendChild(profileSection);

    // ---- Primary tier definition ----
    var defSection = el('div', { className: 'vk-quiz__rec-section' });
    defSection.appendChild(el('h3', { className: 'vk-quiz__rec-section-title' }, 'What is ' + data.name + '?'));
    defSection.appendChild(el('p', { className: 'vk-quiz__rec-definition' }, data.definition));
    card.appendChild(defSection);

    // ---- Why it fits ----
    var whySection = el('div', { className: 'vk-quiz__rec-section' });
    whySection.appendChild(el('h3', { className: 'vk-quiz__rec-section-title' }, 'Why This Fits Your Profile'));
    var whyText = buildWhyItFits(advisorState, primaryTier, data);
    whySection.appendChild(el('p', { className: 'vk-quiz__rec-why' }, whyText));
    card.appendChild(whySection);

    // ---- VaultKi X2 Section ----
    var vkSection = el('div', { className: 'vk-quiz__rec-section vk-quiz__rec-vaultki' });
    vkSection.appendChild(el('h3', { className: 'vk-quiz__rec-section-title' }, 'VaultKi X2 \u2014 Your Seed Phrase Protection'));
    vkSection.appendChild(el('p', { className: 'vk-quiz__rec-vk-detail' }, data.vaultki_detail));
    vkSection.appendChild(el('div', { className: 'vk-quiz__rec-vk-units' }, [
      el('span', { className: 'vk-quiz__rec-vk-units-label' }, 'Recommended VaultKi X2 units: '),
      el('strong', { className: 'vk-quiz__rec-vk-units-count' }, String(units))
    ]));
    card.appendChild(vkSection);

    // ---- Setup Checklist ----
    var setupSection = el('div', { className: 'vk-quiz__rec-section' });
    setupSection.appendChild(el('h3', { className: 'vk-quiz__rec-section-title' }, 'Step-by-Step Setup'));
    var setupOl = el('ol', { className: 'vk-quiz__rec-setup' });
    for (var si = 0; si < data.setup.length; si++) {
      setupOl.appendChild(el('li', null, data.setup[si]));
    }
    setupSection.appendChild(setupOl);
    card.appendChild(setupSection);

    // ---- Common Mistakes ----
    var mistakesSection = el('div', { className: 'vk-quiz__rec-section' });
    mistakesSection.appendChild(el('h3', { className: 'vk-quiz__rec-section-title' }, 'Common Mistakes to Avoid'));
    var mistakesUl = el('ul', { className: 'vk-quiz__rec-mistakes' });
    for (var mi = 0; mi < data.mistakes.length; mi++) {
      mistakesUl.appendChild(el('li', null, data.mistakes[mi]));
    }
    mistakesSection.appendChild(mistakesUl);
    card.appendChild(mistakesSection);

    // ---- Secondary Recommendations ----
    if (secondaryRecs.length > 0) {
      var secSection = el('div', { className: 'vk-quiz__rec-section' });
      secSection.appendChild(el('h3', { className: 'vk-quiz__rec-section-title' }, 'Additional Recommendations'));

      var secList = el('div', { className: 'vk-quiz__rec-secondary' });
      for (var ri = 0; ri < secondaryRecs.length; ri++) {
        var rec = secondaryRecs[ri];
        var secCard = el('div', { className: 'vk-quiz__rec-secondary-card' });

        var secTierName = '';
        if (rec.tier === 'SHAMIR_NOTE') {
          secTierName = 'Shamir Secret Sharing (Inheritance Note)';
        } else if (rec.tier === 'LN') {
          secTierName = 'Lightning Network';
        } else if (tierData[rec.tier]) {
          secTierName = rec.tier + ': ' + tierData[rec.tier].name;
        } else {
          secTierName = rec.tier;
        }

        secCard.appendChild(el('h4', { className: 'vk-quiz__rec-secondary-title' }, secTierName));
        secCard.appendChild(el('p', { className: 'vk-quiz__rec-secondary-reason' }, rec.reason));

        // Add definition for tier recommendations (not SHAMIR_NOTE or LN)
        if (rec.tier !== 'SHAMIR_NOTE' && rec.tier !== 'LN' && tierData[rec.tier]) {
          secCard.appendChild(el('p', { className: 'vk-quiz__rec-secondary-def' }, tierData[rec.tier].definition));
        }

        secList.appendChild(secCard);
      }

      secSection.appendChild(secList);
      card.appendChild(secSection);
    }

    // ---- Upgrade Path ----
    var upgradeSection = el('div', { className: 'vk-quiz__rec-section' });
    upgradeSection.appendChild(el('h3', { className: 'vk-quiz__rec-section-title' }, 'Upgrade Path'));
    upgradeSection.appendChild(el('p', { className: 'vk-quiz__rec-upgrade' }, data.upgrade));
    card.appendChild(upgradeSection);

    // ---- Recovery Testing Note ----
    var recoverySection = el('div', { className: 'vk-quiz__rec-section vk-quiz__rec-recovery' });
    recoverySection.appendChild(el('h3', { className: 'vk-quiz__rec-section-title' }, 'Recovery Testing \u2014 Mandatory'));
    recoverySection.appendChild(el('p', null, 'A setup without a tested recovery path is incomplete. After your setup is in place, perform a full recovery test on a separate device using only your VaultKi X2 backup. If recovery fails, your backup has a problem \u2014 find and fix it now, not when you need it.'));
    card.appendChild(recoverySection);

    // ---- CTA Button ----
    var ctaSection = el('div', { className: 'vk-quiz__rec-cta-section' });

    var ctaLabel = root.getAttribute('data-cta-label') || 'Get Your VaultKi X2';
    var ctaBtn = el('a', {
      className: 'vk-quiz__rec-cta',
      href: productUrl
    }, ctaLabel + (units > 1 ? ' (' + units + ' units)' : ''));

    ctaBtn.addEventListener('click', function() {
      trackEvent('vk_advisor_cta_clicked', {
        cta_type: 'get_vaultki_x2',
        from_tier: primaryTier,
        vaultki_units: units
      });
    });

    ctaSection.appendChild(ctaBtn);

    // Restart quiz button
    var restartBtn = el('button', {
      className: 'vk-quiz__restart-btn',
      type: 'button'
    }, 'Retake the Assessment');

    restartBtn.addEventListener('click', function() {
      resetState();
      quizStarted = true;
      quizFinished = false;
      trackEvent('vk_advisor_started');
      renderQuestion(root);

      var quizRootEl = root.querySelector('#vk-quiz-root');
      if (quizRootEl) {
        quizRootEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    ctaSection.appendChild(restartBtn);

    // Explore in Knowledge Base button
    var exploreBtn = el('button', {
      className: 'vk-quiz__explore-btn',
      type: 'button'
    }, 'Explore ' + data.name + ' in Knowledge Base');

    exploreBtn.addEventListener('click', function() {
      // Switch to KB
      var kbBtn = root.querySelector('[data-mode="kb"]');
      if (kbBtn) {
        kbBtn.click();
      }

      // Switch to self-custody tab
      var selfTab = root.querySelector('[data-tab="self-custody"]');
      if (selfTab) {
        selfTab.click();
      }

      // Open the relevant tier accordion
      var tierArticle = root.querySelector('[data-tier="' + primaryTier + '"]');
      if (tierArticle) {
        var tierHeader = tierArticle.querySelector('.vk-tier__header');
        if (tierHeader && tierHeader.getAttribute('aria-expanded') !== 'true') {
          tierHeader.click();
        }
      }

      // Scroll to it
      if (tierArticle) {
        setTimeout(function() {
          tierArticle.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }

      trackEvent('vk_advisor_cta_clicked', {
        cta_type: 'explore_tier',
        from_tier: primaryTier,
        vaultki_units: units
      });
    });

    ctaSection.appendChild(exploreBtn);
    card.appendChild(ctaSection);

    quizRoot.appendChild(card);

    // Scroll to top of recommendation
    quizRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ---------------------------------------------------------------------------
  // 17. WHY-IT-FITS TEXT BUILDER
  // ---------------------------------------------------------------------------

  function buildWhyItFits(state, primaryTier, data) {
    var holdings = holdingsLabels[state.q2_holdings_value] || 'your holdings';
    var freq = frequencyLabels[state.q3_tx_frequency] || 'your transaction frequency';
    var tech = techLabels[state.q4_tech_level] || 'your experience level';
    var locations = locationLabels[state.q5_secure_locations] || 'your secure locations';
    var concerns = buildConcernList(state);

    var parts = [];

    switch (primaryTier) {
      case 'T1':
        parts.push('With holdings of ' + holdings + ', a hot wallet gives you immediate access and full self-custody without extra hardware.');
        if (state.q3_tx_frequency === 'daily' || state.q3_tx_frequency === 'weekly') {
          parts.push('Your ' + freq + ' transaction frequency benefits from the convenience of a mobile wallet.');
        }
        parts.push('As your holdings grow beyond $1,000, consider upgrading to a hardware wallet (Tier 2) for stronger key isolation.');
        break;

      case 'T2':
        parts.push('With holdings of ' + holdings + ', a hardware wallet moves your private keys offline \u2014 eliminating the remote attack surface that a hot wallet leaves open.');
        parts.push('At the ' + tech + ' level, a singlesig hardware wallet is the right balance of security and simplicity.');
        break;

      case 'T3':
        parts.push('With holdings of ' + holdings + ', a passphrase adds a second authentication factor and creates a hidden wallet.');
        if (state.q5_secure_locations === 'one') {
          parts.push('Since you have only ' + locations + ', the passphrase stored separately serves as your geographic distribution strategy.');
        }
        if (concerns.indexOf('coercion risk') !== -1) {
          parts.push('The passphrase also enables plausible deniability \u2014 under coercion, you can reveal the base wallet while the passphrase-protected wallet remains hidden.');
        }
        break;

      case 'T4':
        parts.push('With holdings of ' + holdings + ' and access to ' + locations + ', distributing your seed phrase backup across geographic locations eliminates any single point of failure.');
        parts.push('Your ' + tech + ' experience level supports managing multiple backup locations effectively.');
        break;

      case 'T5':
        parts.push('With holdings of ' + holdings + ', multisig provides the highest practical security: no single compromised key can move your funds.');
        if (state.q6_multiple_signers === 'yes_two' || state.q6_multiple_signers === 'yes_threshold') {
          parts.push('Your requirement for multiple signers makes multisig the necessary architecture.');
        }
        if (concerns.indexOf('inheritance planning') !== -1 || concerns.indexOf('critical inheritance requirement') !== -1) {
          parts.push('Multisig also creates a natural inheritance structure \u2014 keys can be distributed to trustees or heirs.');
        }
        break;

      case 'T5b':
        parts.push('With holdings of ' + holdings + ', assisted multisig gives you the security of a 2-of-3 setup with professional guidance from a dedicated service.');
        parts.push('At the ' + tech + ' experience level, the guided setup and ongoing support reduce the operational risk of independent multisig.');
        parts.push('This is self-custody \u2014 you hold 2 of 3 keys. The service holds 1 key as a recovery fallback and cannot move your bitcoin without you.');
        break;

      case 'T6':
        parts.push('With holdings of ' + holdings + ' and ' + tech + '-level operational competency, air-gapped multisig provides the maximum possible security. Every signing device is permanently disconnected from all networks.');
        parts.push('This tier has no safety net and no customer support. Your operational discipline and VaultKi X2 backups are the entire recovery infrastructure.');
        break;

      default:
        parts.push('Based on your profile, ' + data.name + ' is the recommended setup for your situation.');
    }

    return parts.join(' ');
  }

  // ---------------------------------------------------------------------------
  // 18. INIT
  // ---------------------------------------------------------------------------

  document.addEventListener('DOMContentLoaded', function() {
    var root = document.querySelector('[data-vk-advisor]');
    if (!root) return;

    initTabs(root);
    initAccordions(root);
    initModeToggle(root);
    initRedirects(root);

    // Ensure quiz panel is hidden on load
    var quizPanel = root.querySelector('[data-mode-panel="quiz"]');
    if (quizPanel) {
      quizPanel.style.display = 'none';
    }

    // Initialize accordion bodies — hidden attr is already set in HTML,
    // just ensure maxHeight and overflow are set for the animation
    var tierBodies = root.querySelectorAll('.vk-tier__body');
    for (var i = 0; i < tierBodies.length; i++) {
      tierBodies[i].style.maxHeight = '0';
      tierBodies[i].style.overflow = 'hidden';
    }
  });

})();
